import { connect } from '@/common/lib/riot-redux';
import { showAction, hideAction } from './action';

import KfTooltipAnchor from './kf-tooltip-anchor.riot';

const mapStateToProps = (state, props) => {
  const tooltips = state.tooltip ?? {};
  return {
    tooltips,
    ...props,
  };
};

const mapDispatchToProps = (dispatch) => ({
  show(payload) {
    dispatch(showAction(payload));
  },
  hide(payload) {
    dispatch(hideAction(payload));
  },
});

export default connect(KfTooltipAnchor, mapStateToProps, mapDispatchToProps);